<template>
  <section class="input-container">
    <div class="inp-f" @click="showSelect">
        <input type="text" class="inp-s" :placeholder="placeholder" v-model="value" disabled>
        <van-icon name="arrow-down" color="#ccc" class="arrow-down" />
    </div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
  </section>
</template>

<script>
import { ActionSheet, Icon, Toast } from "vant";
export default {
  props: {
    actions: Array,
    placeholder: String,
    default: Object
  },
  components: {
      'van-action-sheet': ActionSheet,
      'van-icon': Icon
  },
  data() {
    return {
      show: false,
      value: '',
    };
  },
  created() {
    if (this.default) {
      this.value = this.default.value;
    }
  },
  methods: {
    onSelect(item) {
      // 默认情况下，点击选项时不会自动关闭菜单
      // 可以通过 close-on-click-action 属性开启自动关闭
      this.show = false;
      this.value = item.name;
      this.$emit('setPkey', item.key)
      this.$emit('setServer', item.skey)
    },
    clear(params) {
      this.value = "";
      this.$emit('setServer', "")
    },
    showSelect(item) {
      if (this.actions.length === 0) {
        Toast('请输入正确的游戏名称');
        return false;
      }
      this.show = true;
    },
  }
};
</script>

<style lang="scss" scoped>
.input-container {
  .inp-f {
    margin: 8px 0;
    position: relative;
    .inp-s {
      // color: #000;
    }
    .arrow-down {
        font-size: 38px;
        color: #666;
        position: absolute;
        right: 18px;
        top: 50%;
        transform: translateY(-50%);
    }
  }
}
</style>